export const stripHTMLTags = (
  str: string | null | undefined,
  allowedTags: string[] = [],
): string => {
  if (!str) return "";

  let text;
  if (allowedTags.length > 0) {
    const regex = new RegExp(
      `<(?!/?(?:${allowedTags.join("|")})\\b)[^>]*>`,
      "gi",
    );
    text = str.replace(regex, "");
  } else {
    text = str.replace(/<\/?[^>]+(>|$)/g, "");
  }

  text = text
    .replace(/&nbsp;/g, " ")
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&#39;/g, "'")
    .replace(/&#x2F;/g, "/")
    .replace(/&#\d+;/g, "");

  return text.trim();
};
